import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

// Import styles
import { FieldWrapper, InputStyled, FormError } from './styles';

const InvoiceNumberMaskField = ({
	type = 'text',
	field,
	name = 'pin',
	autoComplete = 'off',
	form: { touched, errors },
	placeholder,
	maskSymbol = '',
	inputFormat,
	modifiers
}) => {
	const isErrorVisible = touched[field.name] && errors[field.name];
	const errorText = errors[field.name] || '';
	return (
		<FieldWrapper>
			<NumberFormat
				mask={maskSymbol}
				format={inputFormat}
				className={`${
					touched[field.name] && errors[field.name] ? 'errors' : ''
				}`}
				type={type}
				name={name}
				autoComplete={autoComplete}
				placeholder={placeholder}
				customInput={InputStyled}
				modifiers={modifiers}
				{...field}
			/>
			<FormError isErrorVisible={isErrorVisible}>{errorText}</FormError>
		</FieldWrapper>
	);
};

InvoiceNumberMaskField.propTypes = {
	type: PropTypes.string.isRequired,
	field: PropTypes.object.isRequired,
	form: PropTypes.shape({
		touched: PropTypes.object.isRequired,
		errors: PropTypes.object.isRequired
	}),
	placeholder: PropTypes.string.isRequired,
	autoComplete: PropTypes.string,
	maskSymbol: PropTypes.string,
	inputFormat: PropTypes.string,
	modifiers: PropTypes.string
};

export default InvoiceNumberMaskField;
